import * as React from 'react';
import { Collapse } from 'react-bootstrap';
import { ProfileInfoContent } from '../components/ProfileInfoContent/ProfileInfoContent';

var UserPanel = function UserPanel(_ref) {
  var isVisible = _ref.isVisible,
      userMenu = _ref.userMenu,
      hide = _ref.hide;
  return /*#__PURE__*/React.createElement(Collapse, {
    "in": isVisible
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-flat-menu"
  }, /*#__PURE__*/React.createElement(ProfileInfoContent, {
    userMenu: userMenu,
    hide: hide
  })));
};

export default UserPanel;